import { View, Text, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import { legibleOn } from '../../lib/contrast'
import { GT_JERSEYS } from '../../lib/badges'
import { Card, SectionLabel } from '../ui'

// Tre riquadri: maglia rosa del Giro, gialla del Tour, rossa della Vuelta, con i giorni in cui l'hai indossata (leader della generale)
export default function GtJerseysCard({ days, bare = false }) {
  const tc = useThemeColors()
  const { t } = useTranslation()
  const body = (
    <View style={s.row}>
      {GT_JERSEYS.map(j => {
        const n = days?.[j.key] ?? 0
        const on = n > 0
        return (
          <View
            key={j.key}
            accessible
            accessibilityLabel={`${t(j.label)}: ${t('badges.days_caption')} ${n}`}
            style={[s.tile, { backgroundColor: on ? j.color + '1A' : tc.bgCard2, borderColor: on ? j.color + '77' : tc.border }]}
          >
            <MaterialCommunityIcons name="tshirt-crew" size={34} color={on ? j.color : tc.textDim} style={!on ? { opacity: 0.6 } : undefined} />
            <Text style={[s.num, { color: on ? tc.text : tc.textMuted }]}>{n}</Text>
            <Text style={[s.name, { color: on ? legibleOn(j.color, tc.bgCard, 3) : tc.textMuted }]} numberOfLines={1}>{t(j.label)}</Text>
            <Text style={[s.cap, { color: tc.textMuted }]} numberOfLines={2}>{t('badges.days_caption')}</Text>
          </View>
        )
      })}
    </View>
  )
  if (bare) return body
  return (
    <Card style={{ marginBottom: 0 }}>
      <SectionLabel mb={10}>{t('badges.jerseys_title')}</SectionLabel>
      {body}
    </Card>
  )
}

const s = StyleSheet.create({
  row: { flexDirection: 'row', gap: 8 },
  tile: { flex: 1, borderWidth: 1, borderRadius: 14, paddingVertical: 12, paddingHorizontal: 6, alignItems: 'center', gap: 2 },
  num: { fontFamily: fonts.condensedBold, fontSize: 30, lineHeight: 34 },
  name: { fontFamily: fonts.condensedBold, fontSize: 13 },
  cap: { fontSize: 12, textAlign: 'center', lineHeight: 15 },
})
